import React from "react";
import GrComponentFactory from "../gr_component_factory";
import GrPropTypes from "../shared/gr_prop_types";
import * as newsfeedHelper from "./newsfeed_helper";
import UserProfileLink from "../user/user_profile_link";

const childNewsfeedItemProps = {
  isChildNewsfeedItem: true,
};
export default GrComponentFactory.createClass({
  displayName: "ChildNewsfeedItem",

  propTypes: {
    user: GrPropTypes.user().isRequired,
    update: React.PropTypes.object.isRequired,
    headerText: React.PropTypes.string.isRequired,
  },

  render(){
    if (newsfeedHelper.isNewsfeedTypeSupported(this.props.update.resourceType)) {
      return (
        <article className="gr-childNewsfeedItem u-defaultType">
          <header className="gr-childNewsfeedItem__header">
            <span className="gr-childNewsfeedItem__headerTitle">
              <UserProfileLink user={this.props.user}/>
              {" "}
              {this.props.headerText}
            </span>
          </header>
          {newsfeedHelper.renderNewsfeedItem(this.props.update, { ...childNewsfeedItemProps, ...(this.props.readOnlyStars ? { readOnlyStars: this.props.readOnlyStars } : {}) })}
        </article>
      );
    } else {
      return null;
    }
  },
});
